const VISORIA_BACKEND_URL =
  process.env.REACT_APP_VISORIA_BACKEND_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  "";
const API_BASE = `${VISORIA_BACKEND_URL}/api/vs-ops`;

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    ...options,
  });

  let body = {};
  try {
    body = await response.json();
  } catch {
    body = {};
  }

  if (!response.ok) {
    const error = new Error(body.error || `HTTP ${response.status}`);
    error.requires2fa = body.requires2fa;
    throw error;
  }

  return body;
}

export const vsOpsApi = {
  getSession: () => request("/session"),
  login: (username, password) =>
    request("/login", {
      method: "POST",
      body: JSON.stringify({ username, password }),
    }),
  verify2fa: (token) =>
    request("/verify-2fa", {
      method: "POST",
      body: JSON.stringify({ token }),
    }),
  logout: () => request("/logout", { method: "POST" }),
  getSales: (params) => {
    const query = new URLSearchParams(params).toString();
    return request(`/sales?${query}`);
  },
  getVisoriaBalance: () => request("/visoria-balance"),
  returnCard: (orderId, keyCode, returnReason = "") =>
    request(`/sales/${encodeURIComponent(orderId)}/return-card`, {
      method: "POST",
      body: JSON.stringify({ keyCode, returnReason }),
    }),
  abortFulfillment: (orderId, reason = "") =>
    request(`/sales/${encodeURIComponent(orderId)}/abort-fulfillment`, {
      method: "POST",
      body: JSON.stringify({ reason }),
    }),
  getWarehouseMeta: () => request("/warehouse/meta"),
  getWarehouse: (params) => {
    const query = new URLSearchParams(params).toString();
    return request(`/warehouse?${query}`);
  },
  addWarehouseCards: (payload) =>
    request("/warehouse", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
  getTurnover: (params) => {
    const query = new URLSearchParams(params).toString();
    return request(`/stats/turnover?${query}`);
  },
  getProfit: (params) => {
    const query = new URLSearchParams(params).toString();
    return request(`/stats/profit?${query}`);
  },
  getWithdrawals: (params) => {
    const query = new URLSearchParams(params).toString();
    return request(`/withdrawals?${query}`);
  },
  createWithdrawal: (payload) =>
    request("/withdrawals", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
  getSettings: () => request("/settings"),
  updateSettings: (values) =>
    request("/settings", {
      method: "PUT",
      body: JSON.stringify(values),
    }),
  setup2fa: () => request("/2fa/setup", { method: "POST" }),
  enable2fa: (token) =>
    request("/2fa/enable", {
      method: "POST",
      body: JSON.stringify({ token }),
    }),
  disable2fa: (password, token) =>
    request("/2fa/disable", {
      method: "POST",
      body: JSON.stringify({ password, token }),
    }),
  changePassword: (currentPassword, newPassword) =>
    request("/password", {
      method: "POST",
      body: JSON.stringify({ currentPassword, newPassword }),
    }),
  getReferrals: () => request("/referrals"),
  createReferral: (payload) =>
    request("/referrals", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
  updateReferral: (id, payload) =>
    request(`/referrals/${encodeURIComponent(id)}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    }),
  getReferralCustomers: (id) =>
    request(`/referrals/${encodeURIComponent(id)}/customers`),
  getReferralWithdrawals: (id) =>
    request(`/referrals/${encodeURIComponent(id)}/withdrawals`),
  createReferralWithdrawal: (id, payload) =>
    request(`/referrals/${encodeURIComponent(id)}/withdrawals`, {
      method: "POST",
      body: JSON.stringify(payload),
    }),
};
